import axios from 'axios';

export default {
  fetchCompanyList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/company', {
      params: paginationParams,
    })
      .then((companies) => {
        commit('setData', companies);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteCompany(_, company) {
    return axios.delete(`/company/${company.id}`);
  },
};
